type SelectOption = { value: string; label: string };

export const toSelectOptions = (strings: string[]): SelectOption[] =>
  strings.map((v) => ({ value: v, label: v }));

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (value: string): string | undefined =>
  !value || EMAIL_REGEX.test(value) ? undefined : "Enter a valid email address";

// Detects "<" followed by a letter, "!", "/" or "?".
// Allows plain text such as "Deals < £10k".
const HTML_MARKUP_REGEX = /<[a-zA-Z!/?]/;

/** react-hook-form validate rule — rejects values that contain HTML markup. */
export const validateNoHtml = (value: unknown): true | string =>
  typeof value === "string" && HTML_MARKUP_REGEX.test(value)
    ? "HTML tags are not allowed"
    : true;

/** Returns an error message string, or undefined if valid. */
export const validateUdNumber = (
  format: string,
  decimalPlaces: number | null,
  name: string,
  value: string
): string | undefined => {
  if (!value) return undefined;
  if (format === "Integer") {
    if (isNaN(Number(value))) return `${name} must be a number`;
    if (!Number.isInteger(Number(value))) return `${name} must be a whole number`;
  }
  if (format === "Float" && decimalPlaces != null) {
    if (isNaN(Number(value))) return `${name} must be a number`;
    const regex = new RegExp(`^-?\\d+(\\.\\d{1,${decimalPlaces}})?$`);
    if (!regex.test(value))
      return `${name} allows up to ${decimalPlaces} decimal place${decimalPlaces === 1 ? "" : "s"}`;
  }
  return undefined;
};

/** react-hook-form validate wrapper — returns true when valid, error string when not. */
export const udNumberValidateRule =
  (format: string, decimalPlaces: number | null, name: string) =>
  (v: unknown): true | string => {
    const error = validateUdNumber(format, decimalPlaces, name, String(v ?? ""));
    return error === undefined ? true : error;
  };
